import { Flex, Grid } from '@chakra-ui/react'
import type { Context } from 'react'
import { useContext } from 'react'

import type { IPaginationContext } from 'BrokerTsLib/src/interfaces/Pagination/Pagination'
import { Pagination as Paginator } from '../components/Pagination'

export function Pagination<T>({
  context,
}: {
  context: Context<IPaginationContext<T>>
}) {
  const { totalCount, currentPage, setCurrentPage, pageSize } =
    useContext(context)

  return (
    totalCount > 0 && (
      <Flex flexGrow={1} flexDir={'column'} justifyContent={'end'}>
        <Grid py={2} px={4} gridTemplateColumns={'1fr auto'}>
          <Paginator
            totalCount={totalCount}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            maxButtonCount={10}
            pageSize={pageSize}
          />
        </Grid>
      </Flex>
    )
  )
}
